(function () {

  function initStickyAddToCart() {

    var bar =
      document.getElementById('sticky-buy-bar');

    var trigger =
      document.getElementById('main-buy-buttons');

    var minusBtn =
      document.getElementById('sticky-qty-minus');

    var plusBtn =
      document.getElementById('sticky-qty-plus');

    var stickyQty =
      document.getElementById('sticky-qty-input');

    var stickyAdd =
      document.getElementById('sticky-add-to-cart');


    if (
      !bar ||
      !trigger ||
      !minusBtn ||
      !plusBtn ||
      !stickyQty ||
      !stickyAdd
    ) {
      return;
    }


    var mobileQuery =
      window.matchMedia('(max-width: 768px)');


    var addingToCart = false;



    /* =========================================
       FIND ORIGINAL PRODUCT CONTROLS
       ========================================= */

    function getMainControls() {

      var mainAddButton =
        trigger.querySelector(
          'button[name="add"]'
        ) ||
        document.querySelector(
          '.product-info__add-button button[name="add"]'
        );


      var mainForm = null;

      var mainQuantity = null;


      if (mainAddButton) {

        mainForm =
          mainAddButton.closest('form');


        if (mainForm) {

          mainQuantity =
            mainForm.querySelector(
              'input[name="quantity"]'
            );

        }

      }


      /*
        Fallback for Canopy themes where the
        quantity input may sit outside the
        immediate form wrapper.
      */

      if (!mainQuantity) {

        mainQuantity =
          trigger.querySelector(
            'input[name="quantity"]'
          ) ||
          document.querySelector(
            'quantity-input input[name="quantity"]'
          ) ||
          document.querySelector(
            '.product-info input[name="quantity"]'
          );

      }


      return {
        button: mainAddButton,
        quantity: mainQuantity
      };

    }



    /* =========================================
       QUANTITY RULES
       ========================================= */

    function getQuantityRules() {

      var controls =
        getMainControls();


      var mainQuantity =
        controls.quantity;


      var min = 1;
      var step = 1;
      var max = null;


      if (mainQuantity) {

        var parsedMin =
          parseFloat(mainQuantity.min);

        var parsedStep =
          parseFloat(mainQuantity.step);

        var parsedMax =
          parseFloat(mainQuantity.max);


        if (!isNaN(parsedMin)) {
          min = parsedMin;
        }


        if (
          !isNaN(parsedStep) &&
          parsedStep > 0
        ) {
          step = parsedStep;
        }


        if (
          !isNaN(parsedMax) &&
          parsedMax > 0
        ) {
          max = parsedMax;
        }

      }


      return {
        min: min,
        step: step,
        max: max
      };

    }



    /* =========================================
       DECREASE QUANTITY
       ========================================= */

    minusBtn.addEventListener(
      'click',
      function () {

        var rules =
          getQuantityRules();


        var current =
          parseFloat(stickyQty.value) ||
          rules.min;


        var next =
          current - rules.step;


        if (next < rules.min) {
          next = rules.min;
        }


        stickyQty.value = next;

      }
    );



    /* =========================================
       INCREASE QUANTITY
       ========================================= */

    plusBtn.addEventListener(
      'click',
      function () {

        var rules =
          getQuantityRules();


        var current =
          parseFloat(stickyQty.value) ||
          rules.min;


        var next =
          current + rules.step;


        if (
          rules.max !== null &&
          next > rules.max
        ) {
          next = rules.max;
        }


        stickyQty.value = next;

      }
    );



    /* =========================================
       STICKY ADD TO CART
       ========================================= */

    stickyAdd.addEventListener(
      'click',
      function (event) {

        event.preventDefault();


        if (addingToCart) {
          return;
        }


        var controls =
          getMainControls();


        var mainAddButton =
          controls.button;

        var mainQuantity =
          controls.quantity;


        if (!mainAddButton) {

          console.warn(
            'Original Add to Cart button not found.'
          );

          return;

        }


        /*
          If original product Add to Cart
          is unavailable / sold out.
        */

        if (
          mainAddButton.disabled ||
          mainAddButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {

          return;

        }


        /*
          Sync sticky quantity with the
          ORIGINAL Canopy product form.
        */

        if (mainQuantity) {

          mainQuantity.value =
            stickyQty.value;


          mainQuantity.dispatchEvent(
            new Event(
              'input',
              {
                bubbles: true
              }
            )
          );


          mainQuantity.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }


        /*
          IMPORTANT:
          Trigger the theme's ORIGINAL
          Add to Cart button.

          Canopy therefore handles:
          - cart/add
          - drawer refresh
          - cart count
          - cart items
          - recommendations
          - notifications
        */

        addingToCart = true;


        stickyAdd.disabled = true;

        stickyAdd.textContent =
          'ADDING...';


        mainAddButton.click();


        /*
          Restore sticky button.
          The Canopy theme continues handling
          the actual cart operation.
        */

        window.setTimeout(
          function () {

            addingToCart = false;


            if (
              !mainAddButton.disabled
            ) {

              stickyAdd.disabled =
                false;

              stickyAdd.textContent =
                'ADD TO CART';

            }

          },
          1400
        );

      }
    );



    /* =========================================
       VARIANT CHANGE
       ========================================= */

    document.addEventListener(
      'variant:change',
      function (event) {

        var variant =
          event.detail &&
          event.detail.variant;


        if (!variant) {
          return;
        }


        stickyQty.value = 1;


        if (variant.available) {

          stickyAdd.disabled = false;

          stickyAdd.textContent =
            'ADD TO CART';

        } else {

          stickyAdd.disabled = true;

          stickyAdd.textContent =
            'SOLD OUT';

        }

      }
    );



    /* =========================================
       SHOW / HIDE STICKY BAR
       ========================================= */

    function updateVisibility() {

      if (!mobileQuery.matches) {

        bar.classList.remove(
          'is-visible'
        );

        return;

      }


      var rect =
        trigger.getBoundingClientRect();


      var scrolledPast =
        rect.bottom < 0;


      bar.classList.toggle(
        'is-visible',
        scrolledPast
      );

    }



    if (
      'IntersectionObserver' in window
    ) {

      var observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                var shouldShow =
                  mobileQuery.matches &&
                  !entry.isIntersecting &&
                  entry.boundingClientRect.bottom < 0;


                bar.classList.toggle(
                  'is-visible',
                  shouldShow
                );

              }
            );

          },
          {
            threshold: 0
          }
        );


      observer.observe(trigger);

    }



    window.addEventListener(
      'scroll',
      updateVisibility,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      updateVisibility
    );


    if (
      mobileQuery.addEventListener
    ) {

      mobileQuery.addEventListener(
        'change',
        updateVisibility
      );

    }


    updateVisibility();

  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initStickyAddToCart
    );

  } else {

    initStickyAddToCart();

  }

})();